import {ref, type Ref} from 'vue';
import type {StrategyRefusalReasonsInner} from '@api';
import {Configuration, ProfileStrategyRefusalReasonsApi} from '@api';

export function useRedirectReasons(profileId: string): {
    reasons: Ref<StrategyRefusalReasonsInner[]>;
    loading: Ref<boolean>;
    error: Ref<string | null>;
} {
    const reasons = ref<StrategyRefusalReasonsInner[]>([]);
    const loading = ref<boolean>(true);
    const error = ref<string | null>(null);

    const _apiConfiguration = new Configuration({basePath: ''});
    const _profileStrategyRefusalReasonsApi = new ProfileStrategyRefusalReasonsApi(_apiConfiguration);

    let _reasonsCache: StrategyRefusalReasonsInner[] | null = null;

    async function _getAll(profileId: string): Promise<StrategyRefusalReasonsInner[]> {
        if (!_reasonsCache) {
            _reasonsCache = await _profileStrategyRefusalReasonsApi.getReasons({profileId});
        }
        return _reasonsCache;
    }

    _getAll(profileId)
        .then((result) => {
            if (result) {
                reasons.value = result;
            }
        })
        .catch((_) => {
            error.value = 'Request error';
        })
        .finally(() => {
            loading.value = false;
        });

    return {
        reasons,
        loading,
        error,
    };
}
